import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { v4 } from 'uuid';
import { styled } from '@mui/material/styles';
import { Box, Stack, Typography, AccordionSummary, AccordionDetails, } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { TypeOptions } from './TypeOptions';
import CustomButton from '../../common/CustomButton';
import CustomSelect from '../../common/CustomSelect';
import { DurationOptions } from './DurationOptions';
import { RatingOptions } from './RatingOptions';
import PriceOptions from './PriceOptions';
import LevelOptions from './LevelOptions';
const StyledAccordion = styled((props) => (
// eslint-disable-next-line react/jsx-props-no-spreading
_jsx(MuiAccordion, { disableGutters: true, elevation: 0, square: true, ...props })))({
    background: 'transparent',
    '& .MuiAccordionDetails-root': {
        padding: '0px 16px !important',
    },
    '& .MuiButtonBase-root': {
        height: '45px !important',
    },
    '& .MuiAccordionSummary-content': {
        margin: '0 !important',
    },
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
});
const sortByOptions = [
    { label: 'Most Relevant', value: v4() },
    { label: 'Highest Rated', value: v4() },
    { label: 'Newest', value: v4() },
    { label: 'Duration Low > Hight', value: v4() },
    { label: 'Duration Hight > Low', value: v4() },
];
const typeOptions = [
    {
        id: v4(),
        name: 'Certificate Program',
        defaultChecked: true,
    },
    {
        id: v4(),
        name: 'Badge',
        defaultChecked: true,
    },
];
const durationOptions = [
    {
        id: v4(),
        start: 0,
        end: 5,
        defaultChecked: false,
    },
    {
        id: v4(),
        start: 5,
        end: 10,
        defaultChecked: false,
    },
];
const ratingOptions = [
    {
        id: v4(),
        min: 4.5,
        count: 350,
        defaultChecked: false,
    },
    {
        id: v4(),
        min: 3.5,
        count: 555,
        defaultChecked: false,
    },
    {
        id: '2',
        min: 2.5,
        count: 1100,
        defaultChecked: false,
    },
];
const SearchFilterPanel = ({ settings: { showFilterButton, showSortByButton, defaultExpanded, showTypeFilter, showDurationFilter, showRatingFitler, showPriceFilter, showLevelFilter, }, }) => {
    const [option, setOption] = useState(sortByOptions[0]);
    const advancedFilters = [
        {
            id: 'panel1',
            title: 'Type',
            show: showTypeFilter,
            expanded: defaultExpanded,
            component: _jsx(TypeOptions, { options: typeOptions }),
        },
        {
            id: 'panel2',
            title: 'Duration',
            show: showDurationFilter,
            expanded: defaultExpanded,
            component: _jsx(DurationOptions, { options: durationOptions }),
        },
        {
            id: 'panel3',
            title: 'Average Rating',
            show: showRatingFitler,
            expanded: defaultExpanded,
            component: _jsx(RatingOptions, { options: ratingOptions }),
        },
        {
            id: 'panel4',
            title: 'Price',
            show: showPriceFilter,
            expanded: defaultExpanded,
            component: _jsx(PriceOptions, {}),
        },
        {
            id: 'panel5',
            title: 'Level',
            show: showLevelFilter,
            expanded: defaultExpanded,
            component: _jsx(LevelOptions, {}),
        },
    ];
    const [expanded, setExpanded] = useState([]);
    const handleExpand = (panelID) => {
        const index = expanded.indexOf(panelID);
        if (index === -1) {
            setExpanded([...expanded, panelID]);
        }
        else {
            const newExpanded = [...expanded];
            newExpanded.splice(index, 1);
            setExpanded(newExpanded);
        }
    };
    const handleExpandAll = (expand) => {
        if (expand) {
            setExpanded(advancedFilters.map((obj) => obj.id));
        }
        else {
            setExpanded([]);
        }
    };
    useEffect(() => {
        handleExpandAll(defaultExpanded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultExpanded]);
    return (_jsxs(Box, { sx: {
            width: 343,
            padding: '25px 18px 25px 21px',
            backgroundImage: (theme) => (theme.palette.subNav.main),
        }, children: [_jsxs(Stack, { direction: "row", justifyContent: "space-between", children: [_jsx(Box, { children: showFilterButton && (_jsx(CustomButton, { startIcon: _jsx(TuneRoundedIcon, {}), label: "FILTER", onClick: () => { }, customStyle: { width: 120 } })) }), _jsx(Box, { children: showSortByButton && (_jsx(CustomSelect, { option: option, options: sortByOptions, setOption: setOption, idField: "value", labelField: "label", customStyle: {
                                width: 170,
                                color: 'text.secondary',
                            } })) })] }), _jsx(Stack, { sx: { background: 'transparent', mt: 2.625 }, children: advancedFilters.map((panel) => (panel.show ? (_jsxs(StyledAccordion, { expanded: panel.id && expanded.includes(panel.id), sx: { mb: 3.75 }, onChange: () => handleExpand(panel.id), children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { sx: { color: 'text.secondary' } }), "aria-controls": "panel1a-content", id: "panel1a-header", sx: {
                                backgroundColor: 'primary.dark',
                                color: 'text.secondary',
                                borderRadius: 1,
                                pl: 2.625,
                            }, children: _jsx(Typography, { variant: "subtitle1", fontWeight: "fontWeightBold", children: panel.title }) }), _jsx(AccordionDetails, { sx: { color: 'primary.main' }, children: panel.component })] }, panel.id)) : null)) })] }));
};
SearchFilterPanel.defaultProps = {
    settings: {
        showFilterButton: true,
        showSortByButton: true,
        defaultExpaned: true,
        showTypeFilter: true,
        showDurationFilter: true,
        showRatingFitler: true,
        showPriceFilter: true,
        showLevelFilter: true,
    },
};
SearchFilterPanel.meta = {
    group: 'hidden',
    name: 'Course search filter panel',
    description: 'Shows course search filter panel',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.defaultExpanded',
            name: 'Default search filter expanded',
            type: 'boolean',
            description: 'Default serach filter expanded.',
        },
        {
            key: 'settings.showFilterButton',
            name: 'Show filter button',
            type: 'boolean',
            description: 'Show filter button.',
        },
        {
            key: 'settings.showSortByButton',
            name: 'Show sort by button',
            type: 'boolean',
            description: 'Show sort by menu button.',
        },
        {
            key: 'settings.showTypeFilter',
            name: 'Show types filter',
            type: 'boolean',
            description: 'Show type filter.',
        },
        {
            key: 'settings.showDurationFilter',
            name: 'Show duration filter',
            type: 'boolean',
            description: 'Show duration filter.',
        },
        {
            key: 'settings.showRatingFitler',
            name: 'Show rating filter',
            type: 'boolean',
            description: 'Show rating filter.',
        },
        {
            key: 'settings.showPriceFilter',
            name: 'Show price filter',
            type: 'boolean',
            description: 'Show price filter.',
        },
        {
            key: 'settings.showLevelFilter',
            name: 'Show level filter',
            type: 'boolean',
            description: 'Show level filter.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'SearchFilterPanel',
        props: {
            settings: {
                showFilterButton: true,
                showSortByButton: true,
                defaultExpanded: true,
                showTypeFilter: true,
                showDurationFilter: true,
                showRatingFitler: true,
                showPriceFilter: true,
                showLevelFilter: true,
            },
        },
    },
};
export default SearchFilterPanel;
//# sourceMappingURL=SearchFilterPanel.js.map